import React, { useRef, useEffect } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { TweenMax, Power2, gsap } from 'gsap'

const media = {
  medium: '@media(min-width:700px)',
  large: '@media(min-width:1200px)',
  xLarge: '@media(min-width:1800px)'
}

const StudentListStyles = styled.ul`
    /* font-size:5.5vw; */
    background:var(--black);
    display:grid;
    grid-template-columns:repeat(2,1fr);
    list-style:none;
    margin-top:1em;
    margin-bottom:0em;
    font-family: var(--serif);
    z-index:10;
    position:relative;
    padding:0;
    ${media.medium}{
      grid-template-columns: repeat(3,1fr);

    }
    ${media.large}{
      /* font-size:6.5vw; */
      grid-template-columns: repeat(3,1fr);
    }
    
    ${media.xLarge}{
      /* font-size:7.5vw; */
      grid-template-columns: repeat(4,1fr);

    }
    
`

const StudentItemStyles = styled.li`
 font-size:var(--medium-text);
  font-weight:500;
  letter-spacing:-0.03em;
  text-transform:uppercase;
  line-height:1em;
  overflow:hidden;
  opacity:0.0;
  transition: all 1s ease-in-out;
  letter-spacing:0.05em;
  &.active{
      transform: scale(1.0) translateX(0%);
      opacity: 1.0;
  }

  span{
    transition: all 0.2s ease-in-out;
  }
 .first-name{
    margin-bottom:6px;
    display:block;
 }
 .last-name{
     margin-top:12px;
     display:block;
 }
  .student-hero{
    max-height:6em;
    margin:0 0.125em;
  
    transform:translateY(0.125em);
    border-radius:6px;
  }
  a{
    color:var(--light);
    display:block;
    text-decoration:none;
    padding:0.1em 0.25em 0.25em 1em;
    text-align:center;
    background:var(--black);
    padding:2em 0;
    font-variation-settings: "wght" 400;
    /* transition: all  1s cubic-bezier(0.28, 0.76, 0.41, 1); */
    
    &:hover{
      /* font-variation-settings:"wght" 400; */

      .first-name{
          transform:translateX(-1em);
      }
      .last-name{
          transform:translateX(1em);
      }

    }
    

    &:active{
      transform:scale(0.9);
      /* background:var(--light); */
      /* color:var(--black); */

    }
  }

  &:last-child{
    border-bottom:none;
  }
`

function SingleStudent ({ student }) {
  // console.log(student.hero_image.asset.fluid.src)

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    if (typeof window !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger)
      gsap.core.globals('ScrollTrigger', ScrollTrigger)
      gsap.config({ nullTargetWarn: false })
    }

    const links = gsap.utils.toArray('.student-list-item')

    // if (links) {
    //   links.forEach(link => {
    //     gsap.from(link, {
    //       // y: '-25%',
    //       // scale: 0.7,
    //       // opacity: 0.0,
    //       scrollTrigger: {
    //         trigger: link,
    //         scrub: false,
    //         toggleClass: 'active',
    //         start: 'top 95%',
    //         end: () => `+=${link.offsetHeight} + 200`
    //       }
    //     })
    //   })
    // }
  })

  return (
    <StudentItemStyles className="student-list-item active">
      <Link className="studentLink" to={`/students/${student.slug.current}`}>
        <span className="first-name">{student.first_name}</span>
        {/* <Img className="student-hero" fluid={student.hero_image.asset.fluid} alt="" /> */}
        <img className="student-hero" src={student.hero_image.asset.fluid.src} alt="" />
        <span className="last-name">{student.last_name}</span>
      </Link>
    </StudentItemStyles>
  )
}

export default function StudentGrid ({ students }) {
  return <section className="studentList">
    <StudentListStyles>
      {students.map((student) => (
        <SingleStudent key={student.id} student={student}/>
      ))}
    </StudentListStyles>
  </section>
}
